var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 31,
    viewBox: "0 0 120 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.9063 17.3483C64.0352 25.6817 21.2513 10.7036 0.526367 1V30H113.526V25.0847L102.449 17.8202C97.9261 14.8539 91.9885 15.4966 86.9063 17.3483Z",
    fill: "url(#paint0_linear_1379_6035)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.456 25.25C108.456 28.1955 110.844 30.5833 113.789 30.5833C116.735 30.5833 119.122 28.1955 119.122 25.25C119.122 22.3045 116.735 19.9167 113.789 19.9167C110.844 19.9167 108.456 22.3045 108.456 25.25ZM0.366256 2.15622C10.9981 7.11661 27.399 13.4507 43.9775 17.3552C52.2677 19.3077 60.6265 20.6584 68.3451 20.9188C76.0537 21.1787 83.19 20.3537 88.9933 17.899L88.2142 16.057C82.7813 18.355 75.9686 19.1747 68.4125 18.9199C60.8663 18.6654 52.6446 17.3417 44.436 15.4085C28.017 11.5415 11.7466 5.25888 1.21187 0.34378L0.366256 2.15622ZM100.873 18.0037L113.242 26.0871L114.336 24.4129L101.967 16.3295L100.873 18.0037ZM88.9933 17.899C92.9917 16.2077 97.5111 15.8069 100.873 18.0037L101.967 16.3295C97.8028 13.6083 92.4956 14.246 88.2142 16.057L88.9933 17.899Z",
    fill: "#A7388E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1379_6035",
    x1: 57.0264,
    y1: 2.9661,
    x2: 57.0264,
    y2: 30.4915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7388E",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7388E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageChart);
export default __webpack_public_path__ + "static/media/ImageChart.c18c7ea2972505cfd7ea2c105bd7c04c.svg";
export { ForwardRef as ReactComponent };